const PREFIX = 'FILTERS_',
APPLY = 'APPLY_',
PARAMETERS = 'PARAMETERS',
RESET = 'RESET_',
SET = 'SET_';

/**
 * @name APPLY_HASH_CHANGE
 * @const
 * @description Applies hash changes that apply to filters
 */
export const APPLY_HASH_CHANGE = PREFIX + APPLY + 'HASH_CHANGE';

/**
 * @name APPLY_HASH_CHANGE
 * @const
 * @description Applies hash changes that apply to filters
 */
export const UPDATE_DEFAULT_PARAMETERS = PREFIX + APPLY + 'DEFAULT_PARAMTERS';

/**
 * @name APPLY_PARAMETERS
 * @const
 * @description Applies the provided parameters to the table
 */
export const APPLY_PARAMETERS = PREFIX + APPLY + PARAMETERS;

/**
 * @name HIDE_PARAMETER
 * @const
 * @description Applies the provided filter to the table
 */
export const HIDE_PARAMETER = PREFIX + 'HIDE_PARAMETER';

/**
 * @name PRIORITIZE_PARAMETER
 * @const
 * @description Toggles dispaly of the description parameters
 */
export const PRIORITIZE_PARAMETER = PREFIX + 'PRIORITIZE_PARAMETER';

/**
 * @name REORDER
 * @const
 * @description Applies the provided filter to the table
 */
export const REORDER = PREFIX + 'REORDER';

/**
 * @name RESET_FILTERS
 * @const
 * @description Resets app to default filters
 */
export const RESET_FILTERS = PREFIX + RESET + 'FILTERS';

/**
 * @name RESET_PARAMETERS
 * @const
 * @description Resets app to default parameters
 */
export const RESET_PARAMETERS = PREFIX + RESET + PARAMETERS;
/**
 * @name RESET_COLUMN
 * @const
 * @description Resets Columns to default parameters
 */
export const RESET_COLUMN = PREFIX + RESET + 'COLUMN';

/**
 * @name RESET_SORT
 * @const
 * @description Clears the sort values from all sorted columns
 */
export const RESET_SORT = PREFIX + RESET + 'SORT';

/**
 * @name SET_PARAMETERS
 * @const
 * @description Sets the parameters for the app
 */
export const SET_PARAMETERS = PREFIX + SET + PARAMETERS;

/**
 * @name SET_QUICK_FILTER
 * @const
 * @description Sets the quick filter for the app
 */
export const SET_QUICK_FILTER = PREFIX + SET + 'QUICK_FILTER';

/**
 * @name SET_TOOLTIP
 * @const
 * @description Sets the tooltip
 */
export const SET_TOOLTIP = PREFIX + SET + 'TOOLTIP';

/**
 * @name SHOW_ALL
 * @const
 * @description Displays all available parameters
 */
export const SHOW_ALL = PREFIX + 'SHOW_ALL';

/**
 * @name SORT_BY_COLUMN
 * @const
 * @description Sort column
 */
export const SORT_BY_COLUMN = PREFIX + 'SORT_BY_COLUMN';

/**
* @name RESET_DETAILS
* @const
* @description Resets details to default parameters
*/
export const RESET_DETAILS = PREFIX + RESET + 'DETAILS';